<template>
    <BaseForm v-if="series && errors">
        <template #fields>
            <TextField
                :value="values.cycle"
                :label="$t('cycle')"
                :error-messages="errors.cycle"
                @input="setFieldValue('cycle', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('cycle', true)"
            />
            <TextAreaField
                :value="values.notesCycle"
                :label="$t('notes-cycle')"
                :error-messages="errors.notesCycle"
                :max-length="ProjectSeriesCycleSchema.shape.notesCycle.maxLength ?? undefined"
                @input="setFieldValue('notesCycle', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('notesCycle', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import TextField from '@/components/Form/TextField.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectSeriesInjection } from '@/project/composables/useProjectSeriesInjection';
import { ProjectSeriesCycleSchema } from '@/project/schemas';
import { computed } from 'vue';

const props = defineProps<{ seriesId: string }>();

const seriesId = computed(() => props.seriesId);

const { series, updateProjectSeries } = useProjectSeriesInjection();

const { values, errors, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    ProjectSeriesCycleSchema,
    computed(() => ({
        cycle: series.value?.cycle ?? '',
        notesCycle: series.value?.notesCycle ?? '',
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateProjectSeries({ id: seriesId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
